import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import { APIUtiltity } from '../../API';
import StarStakeNftCard from '../StarStakeNFT/Common/StarStakeNftCard';

import Icon from '../../img/PeopleCircle.png';

function EnterBrandClubDropdown({ walletId = '' }) {
  const [purchasedSnfts, setPurchasedSnfts] = useState([]);
  const [showPurchasedSnfts, setShowPurchasedSnfts] = useState(false);
  const history = useHistory();

  const getAllPurchaseSnft = async () => {
    const res = await APIUtiltity.getAllPurchaseSnft();
    if (res.status === 200) setPurchasedSnfts(res.data || []);
    else setPurchasedSnfts([]);
  };

  React.useEffect(() => {
    if (walletId) getAllPurchaseSnft();
    else setPurchasedSnfts([]);
  }, [walletId]);

  return purchasedSnfts.length <= 0 ? null : (
    <>
      <img
        src={Icon}
        alt="icon"
        className="dropdown-toggle-icon-brandclubs"
        onClick={() => setShowPurchasedSnfts(!showPurchasedSnfts)}
      />
      <Dropdown
        show={showPurchasedSnfts}
        onMouseEnter={() => setShowPurchasedSnfts(true)}
        onMouseLeave={() => setShowPurchasedSnfts(false)}
        className="header-enter-club-dropdown"
      >
        <Dropdown.Toggle className="dropdown-toggle-btn">
          Enter Campaign Club
        </Dropdown.Toggle>
        <Dropdown.Menu onClick={() => setShowPurchasedSnfts(false)}>
          {purchasedSnfts.map((data = {}, index = 0) => (
            <div
              className="purchased-snft"
              key={index}
              onClick={() => history.push('/BrandClubHome/' + data.snftId)}
            >
              <StarStakeNftCard cardData={data} />
              <div>
                <h4 className="two-line-title">{data.title}</h4>
                <span>Enter Club</span>
              </div>
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

export default EnterBrandClubDropdown;
